import { Stack, Text, Box, Alert } from '@chakra-ui/react';
import React from 'react';

import { Select } from 'packages/common-frontend/components/Select';

export const VersionSelector = ({
  selectedVersion,
  versions,
  setSelectedVersion,
}: {
  selectedVersion: number | null;
  versions: number[];
  setSelectedVersion: (version: number | null) => void;
}) => {
  const selectOptions = versions.map((version) => ({
    label: `Version ${version}`,
    value: version,
  }));

  if (selectOptions.length === 0) {
    return (
      <Alert mt={4} status="warning">
        No versions available
      </Alert>
    );
  }

  return (
    <>
      <Text mt={4}>Select Version</Text>
      <Stack direction="column" spacing={4} mt={1}>
        <Box>
          <Select<number>
            placeholderLabel="Select Version"
            value={selectedVersion || undefined}
            options={selectOptions}
            onChange={(value) => {
              if (typeof value === 'number') {
                setSelectedVersion(value);
              }
            }}
          />
        </Box>
      </Stack>
    </>
  );
};
